export { default as Menu } from './Menu/Menu';
export { default as Reading } from './Reading/Reading';
export { default as Talk } from './Talk/Talk';

